// Arabic strings for the redesigned Delivery analytics workspace
// (components/Reports/DeliveryWorkspace).
const trans = {
  // Nav + page title (unique key — the global "Delivery" = "توصيل" is the order
  // type and must stay as-is; the report wants the definite article).
  "Delivery report": "التوصيل",

  // Section notes / descriptions
  "Delivery SLAs, fulfilment funnel, unit economics and where time goes.":
    "اتفاقيات مستوى التوصيل، ومسار التنفيذ، واقتصاديات الوحدة، وأين يُقضى الوقت.",
  "Delivery SLAs, driver performance and unit economics.":
    "اتفاقيات مستوى التوصيل، وأداء السائقين، واقتصاديات الوحدة.",
  "Driver performance, on-time rate, completed orders and cash collected.":
    "أداء السائقين، ونسبة الالتزام بالوقت، والطلبات المكتملة، والنقد المُحصّل.",
  "Delivery areas, configured rates and order performance.":
    "مناطق التوصيل، والأسعار المُعدّة، وأداء الطلبات.",

  // KPIs + hints
  "Completed deliveries": "عمليات التوصيل المكتملة",
  "Orders delivered by an in-app driver": "الطلبات التي وصّلها سائق داخل التطبيق",
  "On-time rate": "نسبة الالتزام بالوقت",
  "Delivered on or before the promised time (sampled)": "تم التوصيل في الوقت المُحدّد أو قبله (عيّنة)",
  "Median dispatch → delivered (sampled)": "الوسيط من الإرسال إلى التوصيل (عيّنة)",
  "Delivery margin": "هامش التوصيل",
  "Fees charged minus cost paid to drivers": "الرسوم المُحصّلة ناقص التكلفة المدفوعة للسائقين",
  "Assigned to drivers": "المُسندة للسائقين",
  "Orders dispatched to an in-app driver": "الطلبات المُرسلة إلى سائق داخل التطبيق",
  "Cash collected": "النقد المُحصّل",
  "Cash on delivery handled by drivers": "الدفع عند الاستلام الذي تولّاه السائقون",
  "Average delivery time": "متوسط وقت التوصيل",

  // Fulfilment funnel
  "Fulfilment funnel": "مسار التنفيذ",
  "From order to delivered, with where it leaks": "من الطلب إلى التوصيل، مع مواضع التسرّب",
  "Delivery orders": "طلبات التوصيل",
  "Orders assigned": "الطلبات المُسندة",
  "Orders completed": "الطلبات المكتملة",
  Completed: "مكتملة",
  "Failed deliveries": "عمليات التوصيل الفاشلة",
  "failed deliveries": "عملية توصيل فاشلة",
  "never assigned to a driver": "لم تُسند إلى سائق",

  // Economics
  "Delivery economics": "اقتصاديات التوصيل",
  "Fees charged vs cost paid to drivers": "الرسوم المُحصّلة مقابل التكلفة المدفوعة للسائقين",
  "Fees charged to customers": "الرسوم المُحصّلة من العملاء",
  "Cost paid to drivers": "التكلفة المدفوعة للسائقين",
  Margin: "الهامش",
  Loss: "خسارة",
  "Driver cost isn't recorded for this store, so delivery margin can't be calculated.":
    "تكلفة السائق غير مُسجّلة لهذا المتجر، لذا لا يمكن حساب هامش التوصيل.",

  // When & where
  "When deliveries happen": "متى تحدث عمليات التوصيل",
  "Dispatches by hour — red marks late-prone hours": "الإرسال حسب الساعة — الأحمر يشير إلى الساعات المعرّضة للتأخير",
  dispatches: "عمليات إرسال",
  late: "متأخرة",
  "on time": "في الوقت",
  "of timed deliveries arrived late": "من عمليات التوصيل المُوقّتة وصلت متأخرة",
  "Where the volume goes": "أين يتركّز الحجم",
  "Top delivery areas": "أفضل مناطق التوصيل",
  "30%+ late": "+30% متأخرة",
  "50%+ late": "+50% متأخرة",

  // External / empty states
  "External delivery store": "متجر توصيل خارجي",
  "Orders here aren't dispatched through in-app drivers, so on-time, driver and timing metrics aren't recorded. Order volume, delivery fees and areas are still shown.":
    "الطلبات هنا لا تُرسَل عبر سائقي التطبيق، لذا لا يتم تسجيل مقاييس الالتزام بالوقت والسائقين والتوقيت. لا يزال يتم عرض حجم الطلبات ورسوم التوصيل والمناطق.",
  min: "دقيقة",
  "Not tracked for this store": "غير مُتتبَّع لهذا المتجر",
  "No in-app drivers": "لا يوجد سائقون داخل التطبيق",
  "No dispatch timing": "لا يوجد توقيت إرسال",

  // Driver scorecard
  "Driver scorecard": "بطاقة أداء السائقين",
  "Click a driver to see all their deliveries": "اضغط على سائق لعرض جميع عمليات توصيله",
  "Show all drivers": "عرض كل السائقين",
  Showing: "عرض",
  "View all": "عرض الكل",
};

export default trans;
